module.exports = __webpack_public_path__ + "assets/img/png/description-info-video-block/blur-video.png?v=1744189028451";